export function PrivacyPage() {
	return (
		<section className="panel">
			<header className="panel__section">
				<h1 className="panel__title">QuickID プライバシーポリシー</h1>
				<p className="panel__text">
					最終更新日：2025年10月15日／制定日：2025年10月8日
				</p>
				<p className="panel__text">
					QuickID
					プライバシーポリシー（以下「本ポリシー」）は、合同会社Monello（以下「当社」）が提供する
					iOS
					アプリケーション「QuickID」（以下「本サービス」）における本サービス利用者（以下「利用者」）の個人情報の取扱について定めるものです。本サービスの利用者は、本ポリシーに同意することを条件として、本サービスを利用できるものとします。なお、当社は個人情報の保護に関する法律その他の関連法令を遵守し、ユーザーの個人情報を適切に管理・保護いたします。本ポリシーにおいて「個人情報保護法」とは、個人情報の保護に関する法律を意味し、「個人情報」とは、個人情報保護法第2条第1項により定義される個人情報を意味し、「本人」とは、個人情報の主体である個人を意味するものとします。
				</p>
			</header>

			<section className="panel__section">
				<h2 className="panel__section-title">
					1. 事業者の名称・所在地・連絡先
				</h2>
				<p className="panel__text">事業者名：合同会社Monello（Monello LLC）</p>
				<p className="panel__text">
					所在地：〒154-0004 東京都世田谷区太子堂4丁目18番15号 マガザン三軒茶屋2
					3F-3
				</p>
				<p className="panel__text">
					連絡先：
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">2. 適用範囲</h2>
				<p className="panel__text">
					本ポリシーは、本サービスにおいて当社が取得・利用・保管・委託・削除等を行う情報に適用されます。App
					Store
					決済等、第三者が提供するサービスにおける情報取扱いは、各事業者のポリシーに従います。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">3. 取得する情報</h2>
				<p className="panel__text">
					当社は、本サービスの提供にあたり、ユーザーから以下の情報を収集します。
				</p>
				<p className="panel__text">
					利用者が提供する情報：顔写真その他の画像データ（以下「元画像」）、お問い合わせ内容、サポート対応に必要な任意提出情報（メールアドレス、端末機種名等）
				</p>
				<p className="panel__text">
					自動的に取得される技術情報：IPアドレス、リクエスト日時、ユーザーエージェント、エラーログ等の技術ログ
				</p>
				<p className="panel__text">
					利用統計情報（個人を特定できない形）：処理回数、処理時間、機能の利用状況等の匿名化・集計データ
				</p>
				<p className="panel__text">
					決済情報について：有料機能は App Store
					のサブスクリプションにより課金され、当社はクレジットカード番号等の決済情報を直接取得・保有しません。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">4. 取得方法とデータフロー</h2>
				<p className="panel__text">
					利用者が端末からアップロードした元画像（顔画像データ）は、当社が利用する外部のAIサービスを用いて処理します。利用者は、本サービスが元画像のAIサービスを利用して加工等の処理を行うものであることを理解・同意した上で、本サービスに元画像をアップロードするものとします。本サービスにおける元画像の具体的な取扱いについては、次項「5.
					顔画像データの取扱いに関する特則」に詳述します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					5. 顔画像データの取扱いについて
				</h2>
				<p className="panel__text">
					本章は、本サービスの中核機能で利用される顔画像データの取扱いについて、重要な事項を定めるものです。
				</p>
				<p className="panel__text">
					<strong>(1) 収集および利用の目的</strong>
				</p>
				<p className="panel__text">
					当社は、利用者が選択した顔画像データを基に、AIによる新たな画像を生成するという本サービスの機能を提供するためにのみ、顔画像データを収集・利用します。これ以外の目的（例えば、当社独自のAIモデルの学習、利用者プロファイルの作成、広告配信など）のために顔画像データを利用することは一切ありません。
				</p>
				<p className="panel__text">
					<strong>(2) 保存期間および削除方針</strong>
				</p>
				<p className="panel__text">
					当社は、利用者のプライバシーを最大限に尊重し、顔画像データを恒久的に保存することはありません。利用者がアップロードした顔画像データは、後述する第三者のAIサービスによる画像生成を目的として、一時的に安全な保管領域に保存されます。当該データは、画像生成処理の完了後、直ちに削除されます。また、万一処理が正常に完了しない場合に備え、いかなる場合においても保管開始から15分を超えてデータが保持されることのないよう、自動的に破棄する措置を講じています。したがって、顔画像データの保持期間は、本サービスの機能提供に必要不可欠な極めて短い時間に限定されます。
				</p>
				<p className="panel__text">
					<strong>(3) 第三者への委託および委託先における取扱い</strong>
				</p>
				<p className="panel__text">
					本サービスの画像生成機能を実現するため、当社は利用者の顔画像データの取扱いを以下の第三者に委託します。
				</p>
				<p className="panel__text">委託先の名称：Google LLC</p>
				<p className="panel__text">
					利用するサービス：Google Cloud Platform 上の Vertex AI を経由した
					Gemini API
				</p>
				<p className="panel__text">
					委託する理由：本サービスの根幹機能であるAIによる画像生成処理のため。
				</p>
				<p className="panel__text">
					委託先における顔画像データの保存の有無と取扱い：当社は、Google Cloud
					Vertex AI の「データ保持ゼロ (Zero data
					retention)」ポリシーが適用される設定でサービスを運用しています。これにより、当社が画像生成のためにGoogleに送信した顔画像データ（プロンプトに含まれるデータ）は、Googleによって保存されず、GoogleのAIモデルやプロダクトの改善・学習のために利用されることもありません。データは画像生成処理の完了後、速やかに破棄されます。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">6. 利用目的</h2>
				<p className="panel__text">
					当社は、取得した利用者の個人情報を以下の目的のために利用します。また、当社は個人情報を非識別化または統計化することがあります。
				</p>
				<p className="panel__text">
					本サービスの提供・維持・改善（画像生成処理、応答性・品質の最適化）のため
				</p>
				<p className="panel__text">
					不正利用・サービス妨害の検知・防止、セキュリティ確保等、本サービスの安全な利用環境を確保するため
				</p>
				<p className="panel__text">
					お問い合わせ対応、重要なお知らせ等の通知のため
				</p>
				<p className="panel__text">
					統計的情報の作成・分析（個人を特定しない形での機能改善・品質向上）
				</p>
				<p className="panel__text">利用規約違反への対応、法令・規制への対応</p>
				<p className="panel__text">
					上記の利用目的に付随し、またはこれらに関連する事項を遂行するため
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">7. 保存期間・削除方針</h2>
				<p className="panel__text">
					顔画像データ：前項「5.
					顔画像データの取扱いに関する特則」に定めるとおり、画像生成処理完了後に速やかに削除され、恒久的には保存されません。
				</p>
				<p className="panel__text">
					技術ログ・運用ログ：セキュリティ確保・障害対応等のため必要最小限の期間保存し、目的達成後は遅滞なく削除又は匿名化します。
				</p>
				<p className="panel__text">
					統計情報：個人を特定できない形で保管・利用します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">8. 第三者提供・委託・共同利用</h2>
				<p className="panel__text">
					第三者提供：法令に基づく場合、人の生命・身体又は財産の保護、公衆衛生の向上等で必要な場合、国の機関等への協力が必要な場合を除き、本人同意なく第三者に個人情報を提供しません。
				</p>
				<p className="panel__text">
					取扱いの委託：本サービスの提供に必要な範囲で、個人情報の取扱いを外部サービス事業者に委託する場合があります。
					<strong>
						特に、本サービスの中核機能である顔画像データの取扱いに関する委託の詳細は、「5.
						顔画像データの取扱いに関する特則」に定めるとおりです。
					</strong>
					当社は、委託先に対し、個人情報保護法上必要かつ適切な選定・監督を行います。
				</p>
				<p className="panel__text">
					共同利用：現時点で共同利用は行っていません。実施する場合は、範囲・項目・管理者等を本ポリシーに追記し公表します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">9. 国外への移転（越境移転）</h2>
				<p className="panel__text">
					「5.
					顔画像データの取扱いに関する特則」に記載の通り、本サービスはGoogle
					LLCが提供する外部サービスを利用しており、これに伴い顔画像データが同社の管理する日本国外のサーバーで取り扱われることがあります。ただし、前述の通り、当該データは処理完了後に速やかに削除され、恒久的に保存されることはありません。当社は、委託契約等により適切な安全管理措置と守秘義務を課す等、個人情報保護法上必要な措置を行うものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">10. セキュリティ管理措置</h2>
				<p className="panel__text">
					当社は、漏えい・滅失・毀損の防止その他の安全管理のため、次を含む合理的措置を講じます。
				</p>
				<p className="panel__text">
					（組織的）基本方針・取扱規程の整備、権限管理、点検／
				</p>
				<p className="panel__text">（人的）従業者教育・誓約／</p>
				<p className="panel__text">（物理的）入退室・機器管理／</p>
				<p className="panel__text">
					（技術的）アクセス制御、暗号化（TLS 等）、認証情報管理、操作ログ取得
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					11. 生成画像・識別表示に関する事項
				</h2>
				<p className="panel__text">
					生成画像に対し、AI生成物であることの識別に資する表示又は識別子を付す場合があります。利用者は、当該識別子その他の技術的保護手段の回避・除去を行ってはなりません。生成画像は公的な本人確認・身分証明用途には使用しないでください（利用規約参照）。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">12. 未成年者のプライバシー</h2>
				<p className="panel__text">
					本サービスは18歳未満は利用できません。18歳未満の利用が判明したときは、速やかに当該情報の削除等を行います。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					13. 開示等の請求（保有個人データに関する権利）
				</h2>
				<p className="panel__text">
					当社は、個人情報保護法に基づき、保有個人データについて、（1）開示・利用目的の通知、（2）訂正・追加・削除、（3）利用停止・消去、（4）第三者提供の停止のご請求に対応します。
				</p>
				<p className="panel__text">
					宛先：
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
				</p>
				<p className="panel__text">
					（件名例：QuickID 保有個人データ開示請求）
				</p>
				<p className="panel__text">
					必要事項：（a）ご請求内容、（b）本人確認情報（登録メール等）。代理人請求は委任状等をご提出ください。
				</p>
				<p className="panel__text">
					回答期限：原則として受領後30日以内に回答します（法令上応じられない場合は理由を通知）。手数料が生じる場合は事前にご案内します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					14. 行動履歴・第三者トラッキング
				</h2>
				<p className="panel__text">
					本サービスは広告配信目的のサードパーティSDKによる行動追跡を原則として行いません。将来的に導入する場合は、取得項目・目的・オプトアウト手段を本ポリシーに追記し、本サービス内で周知します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">15. 事業譲渡</h2>
				<p className="panel__text">
					事業再編等により運営主体が変更される場合、必要な範囲で個人データが承継先に移転されることがあります。承継後も本ポリシーと同等の水準で適切に取扱います。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">16. ポリシーの変更</h2>
				<p className="panel__text">
					当社は、法令改正やサービス変更に応じて本ポリシーを変更することがあります。重要な変更は本サービス内リンク又はApp
					Store上で周知し、告知において定める効力発生日から適用します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">17. 準拠法・管轄</h2>
				<p className="panel__text">
					本ポリシーは日本法に準拠し、本サービスに起因又は関連する紛争は東京地方裁判所を第一審の専属的合意管轄裁判所とします。
				</p>
			</section>

			<div className="panel__section">
				<p className="panel__text">
					問い合わせ先：
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
				</p>
			</div>
		</section>
	);
}

export default PrivacyPage;
